import { getContentEnvHost } from './environment';
import type { Env } from './types';

export const SANITY_NATIVE_CDN_HOST = 'cdn.sanity.io';

export function getSanityCdnHost(env: Env) {
  const contentHost = getContentEnvHost(env);

  return `sanity-cdn.${contentHost}`;
}

export function getSanityAssetFullUrl(src: string | null | undefined, env: Env): string {
  if (!src) return '';

  try {
    const url = new URL(src);

    if (url.host === SANITY_NATIVE_CDN_HOST) {
      url.host = getSanityCdnHost(env === 'local' ? 'dev' : env);
    }

    return url.toString();
  } catch (_) {
    // Just return whatever value was passed if was a non-valid URL string.
    return src;
  }
}
